// extracted by mini-css-extract-plugin
export default {"layout":"Statistics_layout__HqHwo","sections":"Statistics_sections__pRyYZ","periodBar":"Statistics_periodBar__WWEHW","anchor":"Statistics_anchor__oHo5k"};